import { CHANNEL_LABEL, DELIVERY_STATUS, SKIP_REASON_LABEL, toOptions } from "../../features/monitor.constants";

// Advanced filter of the Deliveries list. Every key must also be in FILTER_FIELDS of the backend's
// reminder_monitor/delivery/controller.js, the whitelist get-all filters on.
export const deliveryFilterFields = [
  { key: "status", label: "Status", type: "enum", group: "Message", options: toOptions(DELIVERY_STATUS) },
  { key: "channel_key", label: "Channel", type: "enum", group: "Message", options: toOptions(CHANNEL_LABEL) },
  { key: "skip_reason", label: "Skip reason", type: "enum", group: "Message", options: toOptions(SKIP_REASON_LABEL) },
  { key: "rule_fid", label: "Rule", type: "select", group: "Message", optionsKey: "rules", optionLabel: "name", optionValue: "id" },
  { key: "instance_fid", label: "Case id", type: "int", group: "Message" },
  { key: "recipient_user_fid", label: "Recipient user id", type: "int", group: "Message" },
  { key: "step_no", label: "Step", type: "int", group: "Message" },
  { key: "is_escalation", label: "Escalation", type: "boolean", group: "Message" },
  { key: "sent_at", label: "Sent", type: "datetime", group: "Dates" },
  { key: "created_date", label: "Created", type: "datetime", group: "Dates" },
];
